import React from 'react';
import { Alert, Typography } from '@mui/material';

function StreakDiagnosisBanner({ report }) {
  if (!report) return null;

  const { summary, userTimezone } = report;
  const hasIssues = (summary?.daysWithIssues || 0) > 0;
  const diagnosis = summary?.diagnosis;

  if (!diagnosis && !userTimezone) return null;

  return (
    <Alert severity={hasIssues ? 'warning' : 'info'} sx={{ mb: 2 }}>
      {diagnosis && (
        <Typography variant="body1" sx={{ fontWeight: 600, mb: userTimezone ? 0.5 : 0 }}>
          {diagnosis}
        </Typography>
      )}
      {userTimezone && (
        <Typography variant="body2" color="text.secondary">
          User timezone: {userTimezone}
        </Typography>
      )}
    </Alert>
  );
}

export default StreakDiagnosisBanner;
